import de from './languages/de'
import en from './languages/en'
import es from './languages/es'
import sv from './languages/sv'

export default {
  de,
  en,
  es,
  sv
}
